import { PropsWithChildren, FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';

type Props = PropsWithChildren & { className?: string };

const Subtitle: FunctionComponent<Props> = ({ children, className }) => (
  <div
    className={twMerge(
      'text-base font-semibold text-center text-balance text-structural-darkest',
      className,
    )}
  >
    {children}
  </div>
);

export default Subtitle;
